"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5519],{

/***/ 91468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const baseStyles = {
    solid: "inline-flex justify-center rounded-lg py-2 px-3 text-sm font-semibold outline-2 outline-offset-2 transition-colors",
    outline: "inline-flex justify-center rounded-lg border py-[calc(theme(spacing.2)-1px)] px-[calc(theme(spacing.3)-1px)] text-sm outline-2 outline-offset-2 transition-colors"
};
const variantStyles = {
    solid: {
        primary: "relative overflow-hidden bg-primary text-white before:absolute before:inset-0 active:before:bg-transparent hover:before:bg-white/10 active:bg-primary/90 active:text-white/80 before:transition-colors",
        secondary: "bg-secondary text-white hover:bg-secondary/90 active:bg-secondary/90 active:text-white/70",
        white: "bg-white text-cyan-900 hover:bg-white/90 active:bg-white/90 active:text-cyan-900/70",
        disabled: "bg-gray-200 text-gray-500 cursor-not-allowed"
    },
    outline: {
        primary: "border-primary text-gray-900 hover:border-gray-400 active:bg-gray-100 active:text-gray-700/80",
        disabled: "border-gray-200 text-gray-500 cursor-not-allowed"
    }
};
const variantSize = {
    sm: "px-2.5 py-1.5 text-xs font-medium",
    md: "px-3 py-2 text-sm font-medium leading-4",
    lg: "px-4 py-2 text-sm font-medium",
    xl: "px-4 py-2 text-base font-medium",
    "2xl": "px-6 py-3 text-base font-medium"
};
const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { variant ="solid" , color ="primary" , size ="lg" , className , block =false , loading =false , ...rest } = param;
    const classes = (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseStyles[variant], variantStyles[variant][color], variantSize[size], className, {
        "w-full": block
    });
    if (loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "flex animate-pulse space-x-2 py-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2 w-2 rounded-full bg-white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2 w-2 rounded-full bg-white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-2 w-2 rounded-full bg-white"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        ref: ref,
        className: classes,
        ...rest
    });
});
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 56438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const SeoHead = (props)=>{
    const { seo  } = props;
    const { canonicalUrl  } = seo;
    const twitter = seo.socials.find((social)=>social.network === "twitter");
    const facebook = seo.socials.find((social)=>social.network === "facebook");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            facebook && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: facebook.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: facebook.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: seo.canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(facebook.image.data.attributes.url)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Codealo"
                    })
                ]
            }),
            twitter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: twitter.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: twitter.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(twitter.image.data.attributes.url)
                    })
                ]
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: seo.robots
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 60699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56438);
/* harmony import */ var _organisms_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35604);
/* harmony import */ var _organisms_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58620);





const DefaultLayout = (param)=>{
    let { seo , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex min-h-screen flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: "flex-1",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 77886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_uploadUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80831);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_components_atoms_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91468);
/* harmony import */ var src_components_atoms_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58605);







function BackgroundIllustration(props) {
    let id = (0,react__WEBPACK_IMPORTED_MODULE_3__.useId)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                viewBox: "0 0 1026 1026",
                fill: "none",
                "aria-hidden": "true",
                className: "absolute inset-0 h-full w-full animate-spin-slow",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1025 513c0 282.77-229.23 512-512 512S1 795.77 1 513 230.23 1 513 1s512 229.23 512 512Z",
                        stroke: "#D4D4D4",
                        strokeOpacity: "0.7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M513 1025C230.23 1025 1 795.77 1 513",
                        stroke: "url(#".concat(id, "-gradient-1)"),
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                            id: "".concat(id, "-gradient-1"),
                            x1: "1",
                            y1: "513",
                            x2: "1",
                            y2: "1025",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                    stopColor: "#F65435"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#F65435",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                viewBox: "0 0 1026 1026",
                fill: "none",
                "aria-hidden": "true",
                className: "absolute inset-0 h-full w-full animate-spin-reverse-slower",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M913 513c0 220.914-179.086 400-400 400S113 733.914 113 513s179.086-400 400-400 400 179.086 400 400Z",
                        stroke: "#D4D4D4",
                        strokeOpacity: "0.7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M913 513c0 220.914-179.086 400-400 400",
                        stroke: "url(#".concat(id, "-gradient-2)"),
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                            id: "".concat(id, "-gradient-2"),
                            x1: "913",
                            y1: "513",
                            x2: "913",
                            y2: "913",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                    stopColor: "#F65435"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#F65435",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const Hero = (param)=>{
    let { header , subHeader , image , button  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "overflow-hidden py-20 sm:py-32 lg:pb-32 xl:pb-36",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_atoms_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:grid lg:grid-cols-12 lg:gap-x-8 lg:gap-y-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative z-10 mx-auto max-w-2xl lg:col-span-7 lg:max-w-none lg:pt-6 xl:col-span-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-4xl font-medium tracking-tight text-gray-900",
                                children: header
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "my-6 text-lg text-gray-600",
                                children: subHeader
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: button.url,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_atoms_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        type: "button",
                                        size: "xl",
                                        color: "primary",
                                        variant: "solid",
                                        children: button.label
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative mt-10 sm:mt-20 lg:col-span-5 lg:row-span-2 lg:mt-0 xl:col-span-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackgroundIllustration, {
                                className: "absolute left-1/2 top-4 h-[1026px] w-[1026px] -translate-x-1/3 stroke-gray-300/70 [mask-image:linear-gradient(to_bottom,white_20%,transparent_75%)] sm:top-16 sm:-translate-x-1/2 lg:-top-16 lg:ml-12 xl:-top-14 xl:ml-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative flex items-center justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: (0,_utils_uploadUtils__WEBPACK_IMPORTED_MODULE_6__/* .getUploadUrl */ .M)(image.data.attributes),
                                    width: 720,
                                    height: 720,
                                    alt: image.data.attributes.alternativeText,
                                    className: ""
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Hero);


/***/ }),

/***/ 44712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home_PrimaryFeatures; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js + 2 modules
var tabs = __webpack_require__(59965);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(24697);
// EXTERNAL MODULE: ./src/utils/uploadUtils.ts
var uploadUtils = __webpack_require__(80831);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 181 modules
var motion = __webpack_require__(13454);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/atoms/CircleBackground/index.tsx


const CircleBackground = (param)=>{
    let { color , width =558 , height =558 , ...props } = param;
    let id = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 558 558",
        width: width,
        height: height,
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: id,
                    x1: "79",
                    y1: "16",
                    x2: "105",
                    y2: "237",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: color,
                            stopOpacity: "0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: ".2",
                d: "M1 279C1 125.465 125.465 1 279 1s278 124.465 278 278-124.465 278-278 278S1 432.535 1 279Z",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 279C1 125.465 125.465 1 279 1",
                stroke: "url(#".concat(id, ")"),
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var atoms_CircleBackground = (CircleBackground);

// EXTERNAL MODULE: ./node_modules/@cloudinary/react/index.js
var _cloudinary_react = __webpack_require__(27410);
// EXTERNAL MODULE: ./node_modules/@cloudinary/url-gen/instance/Cloudinary.js + 42 modules
var Cloudinary = __webpack_require__(75505);
;// CONCATENATED MODULE: ./src/components/atoms/CloudinaryVideo/index.tsx



const CloudinaryVideo = (param)=>{
    let { media  } = param;
    // Create and configure your Cloudinary instance.
    const cld = new Cloudinary/* Cloudinary */.r({
        cloud: {
            cloudName: "codealodev"
        }
    });
    // Use the video with public ID, 'docs/walking_talking'.
    const video = cld.video(media.data.attributes.provider_metadata.public_id);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_cloudinary_react/* AdvancedVideo */.xl, {
            cldVid: video,
            controls: true
        })
    });
};
/* harmony default export */ var atoms_CloudinaryVideo = (CloudinaryVideo);

// EXTERNAL MODULE: ./src/components/atoms/Container/index.tsx
var Container = __webpack_require__(58605);
// EXTERNAL MODULE: ./src/components/atoms/DynamicHeroIcon/index.tsx
var DynamicHeroIcon = __webpack_require__(37389);
;// CONCATENATED MODULE: ./src/components/templates/Home/PrimaryFeatures.tsx












const headerAnimation = {
    initial: {
        opacity: 0,
        transition: {
            duration: 0.3
        }
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.3,
            delay: 0.3
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.3
        }
    }
};
const maxZIndex = 2147483647;
function usePrevious(value) {
    let ref = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
function FeatureMedia(param) {
    let { feature  } = param;
    var ref;
    switch((ref = feature.media.data.attributes.provider_metadata) === null || ref === void 0 ? void 0 : ref.resource_type){
        case "video":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_CloudinaryVideo, {
                media: feature.media
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (0,uploadUtils/* getUploadUrl */.M)(feature.media.data.attributes),
                alt: feature.media.data.attributes.alternativeText,
                width: "720",
                height: 720 / 2
            });
    }
}
function FeaturesDesktop(param) {
    let { features  } = param;
    let [changeCount, setChangeCount] = (0,react.useState)(0);
    let [selectedIndex, setSelectedIndex] = (0,react.useState)(0);
    let prevIndex = usePrevious(selectedIndex);
    let isForwards = prevIndex === undefined ? true : selectedIndex > prevIndex;
    let onChange = (0,index_module/* useDebouncedCallback */.y1)((selectedIndex)=>{
        setSelectedIndex(selectedIndex);
        setChangeCount((changeCount)=>changeCount + 1);
    }, 100, {
        leading: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tab.Group */.O.Group, {
        as: "div",
        className: "grid grid-cols-12 items-center gap-8 lg:gap-16 xl:gap-24",
        selectedIndex: selectedIndex,
        onChange: onChange,
        vertical: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
                className: "relative z-10 order-last col-span-6 space-y-6",
                children: features.map((feature, featureIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative rounded-2xl transition-colors hover:bg-gray-800/30",
                        children: [
                            featureIndex === selectedIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                layoutId: "activeBackground",
                                className: "absolute inset-0 bg-gray-800",
                                initial: {
                                    borderRadius: 16
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative z-10 p-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroIcon/* default */.Z, {
                                        icon: feature.icon,
                                        className: "h-8 w-8 text-white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "mt-6 text-lg font-semibold text-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tab */.O, {
                                            className: "text-left [&:not(:focus-visible)]:focus:outline-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "absolute inset-0 rounded-2xl"
                                                }),
                                                feature.title
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2 text-sm text-gray-400",
                                        children: feature.description
                                    })
                                ]
                            })
                        ]
                    }, feature.title))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative col-span-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_CircleBackground, {
                            color: "#F65435",
                            className: "animate-spin-slower"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-10 mx-auto w-full rounded bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureMedia, {
                            feature: features[selectedIndex]
                        })
                    })
                ]
            })
        ]
    });
}
function FeaturesMobile(param) {
    let { features  } = param;
    let [activeIndex, setActiveIndex] = (0,react.useState)(0);
    let slideContainerRef = (0,react.useRef)(null);
    let slideRefs = (0,react.useRef)([]);
    (0,react.useEffect)(()=>{
        let observer = new window.IntersectionObserver((entries)=>{
            for (let entry of entries){
                if (entry.isIntersecting) {
                    setActiveIndex(slideRefs.current.indexOf(entry.target));
                    break;
                }
            }
        }, {
            root: slideContainerRef.current,
            threshold: 0.6
        });
        for (let slide of slideRefs.current){
            if (slide) {
                observer.observe(slide);
            }
        }
        return ()=>{
            observer.disconnect();
        };
    }, [
        slideContainerRef,
        slideRefs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: slideContainerRef,
                className: "flex snap-x snap-mandatory overflow-x-auto overscroll-x-contain scroll-smooth pb-4 [scrollbar-width:none] sm:-space-x-6 [&::-webkit-scrollbar]:hidden",
                children: features.map((feature, featureIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: (ref)=>slideRefs.current[featureIndex] = ref,
                        className: "w-full flex-none snap-center px-4 sm:px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative transform overflow-hidden rounded-2xl bg-gray-800 px-5 py-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative mx-auto w-full max-w-[366px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureMedia, {
                                        feature: feature
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inset-x-0 bottom-0 bg-gray-800/95 p-6 backdrop-blur sm:p-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroIcon/* default */.Z, {
                                            icon: feature.icon,
                                            className: "h-8 w-8 text-white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mt-6 text-sm font-semibold text-white sm:text-lg",
                                            children: feature.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2 text-sm text-gray-400",
                                            children: feature.description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, featureIndex))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 flex justify-center gap-3",
                children: features.map((_, featureIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx_m/* default */.Z)("relative h-0.5 w-4 rounded-full", featureIndex === activeIndex ? "bg-gray-300" : "bg-gray-500"),
                        "aria-label": "Go to slide ".concat(featureIndex + 1),
                        onClick: ()=>{
                            slideRefs.current[featureIndex].scrollIntoView({
                                block: "nearest",
                                inline: "nearest"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute -inset-x-1.5 -inset-y-3"
                        })
                    }, featureIndex))
            })
        ]
    });
}
const PrimaryFeatures = (param)=>{
    let { features  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "features-cards",
        "aria-label": "Nuestras funcionalidades",
        className: "bg-dark pb-20 sm:pb-36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesMobile, {
                    features: features
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "hidden md:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesDesktop, {
                    features: features
                })
            })
        ]
    });
};
/* harmony default export */ var Home_PrimaryFeatures = (PrimaryFeatures);


/***/ })

}]);